import React, { useState, useEffect, useRef } from "react";
import classNames from "../../classNames";

let timeout;

function InputSearch({ className, onSubmit, dropdownOptions, ...option }) {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  function onChange(value) {
    clearTimeout(timeout);
    setInputValue(value);
    onSubmit(value);
    if (value === "") {
      onSubmit(value);
      setDropdownVisible(false);
      setFilteredOptions([]);
      return;
    }

    const filtered = dropdownOptions.filter((option) =>
      option.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);

    setDropdownVisible(filtered.length > 0);
  }

  function onOptionSelect(option) {
    setInputValue(option);
    onSubmit(option);
    setDropdownVisible(false);
  }

  function handleClickOutside(event) {
    if (
      inputRef.current &&
      dropdownRef.current &&
      !inputRef.current.contains(event.target) &&
      !dropdownRef.current.contains(event.target)
    ) {
      setDropdownVisible(false);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classNames("input-group", className)}
      style={{ position: "relative" }}
    >
      <i
        className="bi bi-search position-absolute"
        style={{
          zIndex: 4,
          width: "50px",
          height: "50px",
          lineHeight: "40px",
          textAlign: "center",
        }}
      />
      <input
        ref={inputRef}
        onChange={(e) => onChange(e.target.value)}
        type="search"
        className="form-control rounded ps-5"
        value={inputValue}
        {...option}
      />
      {dropdownVisible && (
        <ul
          ref={dropdownRef}
          className="dropdown-menu show"
          style={{
            position: "absolute",
            maxHeight: "200px",
            top: "100%",
            left: 0,
            zIndex: 1050,
            width: "100%",
            overflow: "auto",
          }}
        >
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              onClick={() => onOptionSelect(option)}
              className="dropdown-item"
              style={{
                cursor: "pointer",
                width: "100%",
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default InputSearch;
